import React, {useState, useEffect} from 'react'
import {withRouter} from 'react-router-dom'
import CollectForm from '../../../components/DeliveryOrder/CollectForm'
import ARTLogs from '../../../components/ART/logs'
const DeliveryOrderCollect = ()=>{
  return (
    <div className="container pt-4">
      <div className="d-flex justify-content-between align-items-center">
          <h4
            className="text-brand"
            style={{
              fontWeight: "600",
              fontSize: "18px",
              color: "#495057",
              lineHeight: "13px",
            }}
          >
            Delivery Order Collection
          </h4>
        </div>
      <CollectForm />
      {/* <ARTLogs /> */}
    </div>
  )
}
    export default withRouter(DeliveryOrderCollect) 
